import * as pako from "pako";
import { uploadCompressedFile, uploadFile } from "../../docuclipper/api";
import { Document, File } from "../../docuclipper/DocuclipperTypes";
import { onProgress } from "../../utils/utils";
import { openModal } from "./ModalManager";
import { createAlert } from "./Alerts";

const ADD_FILE = "add-file";
const UPDATE_FILE = "update-file";
const ADD_PAGES = "add-pages";
const REMOVE_FILE = "remove-file";

export type AddFileFn = ({
  file,
  isCamera,
  asyncProcessing,
  customerId,
  withCompression,
  existing,
}: {
  file: File["file"];
  isCamera: boolean;
  asyncProcessing: boolean;
  customerId: string | number | null;
  withCompression: boolean;
  existing?: boolean;
}) => any;
export const addFile = ({
  file,
  isCamera,
  asyncProcessing,
  customerId,
  withCompression,
  password,
  existing,
}: {
  file: File["file"];
  isCamera: boolean;
  asyncProcessing: boolean;
  customerId: string | number | null;
  withCompression: boolean;
  password?: string;
  existing?: boolean;
}) => async (dispatch) => {
  existing = existing || false;
  dispatch({
    type: existing ? UPDATE_FILE : ADD_FILE,
    payload: {
      file: {
        file,
        uploading: true,
        split: false,
      },
    },
  });
  let document: Document | null = null;
  try {
    const maybeCustomerId = customerId ? `&customerId=${customerId}` : "";
    const maybePassword = password ? `&password=${password}` : "";
    const endpoint = `${isCamera ? "document/cameraimage" : "document"
      }?asyncProcessing=${asyncProcessing}${maybeCustomerId}${maybePassword}`;

    const helper = async (data) => {
      const onprogress = onProgress((progress) =>
        dispatch({
          type: UPDATE_FILE,
          payload: {
            file: {
              file,
              progress,
            },
          },
        })
      );

      if (withCompression) {
        const { content, file } = data;
        document = await uploadCompressedFile({
          content,
          file,
          onprogress,
        });
      } else {
        try {
          document = await uploadFile(data, endpoint, onprogress);
        } catch (err) {
          if (err.errorCode !== 1064) {
            dispatch(createAlert({
              message: (err as any).message || 'Error uploading file',
              timeout: 0, type: 'error'
            }));
            throw err;
          } else {
            dispatch({
              type: UPDATE_FILE,
              payload: {
                file: {
                  file,
                  needsPassword: true,
                },
              },
            });
            dispatch(openModal("password", {}));
          }
        }
      }
      dispatch({
        type: UPDATE_FILE,
        payload: {
          file: {
            file,
            document,
            uploading: false,
            status: "ok",
          },
        },
      });
      if (document) {
        const numPages = parseInt(document.numPages.toString(), 10);

        // TEMPLATE FIELD STUFF
        // dispatch(setDocument(document));
        // dispatch(deleteAllFields());
        // dispatch({
        //   type: SET_NUM_PAGES,
        //   payload: {
        //     numPages,
        //   },
        // });

        dispatch({
          type: ADD_PAGES,
          payload: {
            pages: Array.from(Array(numPages).keys()).map((pageNumber) => ({
              pageNumber,
              documentId: document
                ? parseInt(document.id.toString(), 10)
                : null,
            })),
          },
        });
      }
    };

    if (withCompression) {
      const fileReader = new FileReader();
      fileReader.onload = async function (e) {
        // console.log("original size", (fileReader.result as string).length);
        const compressedContent = pako.deflate(fileReader.result as string, {
          level: 1,
          to: "string",
        });
        // console.log("compressed size", compressedContent.length);

        await helper({
          content: compressedContent,
          file: {
            name: file.name,
            lastModified: file.lastModified,
            size: file.size,
            type: file.type,
            path: file.path,
          },
        });
      };
      fileReader.readAsBinaryString(file as any);
    } else {
      await helper(file);
    }
  } catch (err) {
    dispatch({
      type: REMOVE_FILE,
      payload: {
        file: {
          file: {
            uuid: file.uuid,
          },
        },
      },
    });
  }
};

export type RemoveFileFn = ({ file }: { file: File }) => any;
export const removeFile = ({ file }: { file: File }) => async (dispatch) => {
  dispatch({
    type: REMOVE_FILE,
    payload: {
      file,
    },
  });
  //   try {
  //     if (file.document) {
  //       await deleteDocument(file.document.id);
  //       dispatch({
  //         type: DELETE_PAGES,
  //         payload: {
  //           documentId: parseInt(file.document.id.toString(), 10),
  //         },
  //       });
  //     }
  //   } catch (err) {
  //     return;
  //   }
};
